export default "__VITE_ASSET__CPGrQ49i__"